import { useAdminStaffList } from '@/features/users/admin-staff/hooks/useAdminStaffList';
import { AdminStaffTable } from '@/features/users/admin-staff/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['role', 'phoneNumber', 'emailAddress', 'status', 'username', 'createdDate']),
  desc: z.boolean(),
});

const AdminStaffSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});
export const Route = createFileRoute('/(app)/users/admin/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => AdminStaffSearchSchema.parse(search),
});

function RouteComponent() {
  const { adminStaff, isLoading, pagination } = useAdminStaffList();
  return (
    <div className="flex items-center gap-4">
      <AdminStaffTable data={adminStaff} isLoading={isLoading} pagination={pagination} />
    </div>
  );
}
